<ng-container *ngIf="reversalForm">
	<div class="row">
		<div class="col-md-12">
			<h5 class="mb-3">Payment Reversal</h5>
			<form [formGroup]="reversalForm">
				<div class="row">
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Transaction Date</mat-label>
							<input matInput [matDatepicker]="picker" formControlName="date">
							<mat-hint>MM/DD/YYYY</mat-hint>
							<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Amount</mat-label>
							<input matInput formControlName="amount" />
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Location</mat-label>
							<mat-select formControlName="location">
								<mat-option [value]="''">Use original location</mat-option>
								<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
									{{loc.loccode}} - {{loc.locationname}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Reason</mat-label>
							<input matInput formControlName="reason" placeholder="Reason for reversal">
						</mat-form-field>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col-md-12 d-flex align-items-center gap-3">
						<button mat-raised-button color="accent" (click)="createRefund()">Reverse Payment</button>
						<mat-slide-toggle formControlName="card">Refund Card</mat-slide-toggle>
					</div>
				</div>
			</form>
		</div>
	</div>
</ng-container>
